import { useState } from 'react'
import { useBrandColors } from '../../hooks/useBrandColors'

const allEmployees = [
  { name: 'Jamie Mitchell',  initials: 'JM' },
  { name: 'Sam Rivera',      initials: 'SR' },
  { name: 'Kim Park',        initials: 'KP' },
  { name: 'Dana Lee',        initials: 'DL' },
  { name: 'Marcus Thomas',   initials: 'MT' },
  { name: 'Jordan Collins',  initials: 'JC' },
  { name: 'Paula Reyes',     initials: 'PR' },
  { name: 'Alex Kim',        initials: 'AK' },
  { name: 'Chris Morgan',    initials: 'CM' },
  { name: 'Taylor Reed',     initials: 'TR' },
  { name: 'Morgan Hayes',    initials: 'MH' },
  { name: 'Riley Santos',    initials: 'RS' },
  { name: 'Casey Brooks',    initials: 'CB' },
  { name: 'Drew Patel',      initials: 'DP' },
  { name: 'Avery Chen',      initials: 'AC' },
  { name: 'Quinn Foster',    initials: 'QF' },
  { name: 'Blake Torres',    initials: 'BT' },
  { name: 'Sage Williams',   initials: 'SW' },
]

export default function DocLibrary() {
  const { accent, accentLight, accentBg } = useBrandColors()
  const [search, setSearch] = useState('')
  const [filter, setFilter] = useState('All')
  const [expanded, setExpanded] = useState(null)
  const [toast, setToast] = useState(null)

  const docs = [
    { title: 'Employee Handbook 2025',        type: 'Policy',   uploaded: 'Jan 1, 2025',  size: '2.4 MB', sigRequired: true,  sigCount: 11, totalEmp: 18,
      signed: ['Jamie Mitchell','Sam Rivera','Kim Park','Dana Lee','Alex Kim','Chris Morgan','Taylor Reed','Morgan Hayes','Riley Santos','Casey Brooks','Drew Patel'] },
    { title: 'Code of Conduct',               type: 'Policy',   uploaded: 'Jan 1, 2025',  size: '0.8 MB', sigRequired: true,  sigCount: 18, totalEmp: 18,
      signed: allEmployees.map(e=>e.name) },
    { title: 'Parking Policy - May 2025',     type: 'Policy',   uploaded: 'Mar 25, 2025', size: '0.3 MB', sigRequired: true,  sigCount: 7,  totalEmp: 18,
      signed: ['Jamie Mitchell','Sam Rivera','Kim Park','Dana Lee','Alex Kim','Chris Morgan','Taylor Reed'] },
    { title: 'Onboarding Checklist Template', type: 'Template', uploaded: 'Jan 1, 2025',  size: '0.5 MB', sigRequired: false, sigCount: 0,  totalEmp: 0,  signed: [] },
    { title: 'Performance Review Form',       type: 'Template', uploaded: 'Jan 1, 2025',  size: '0.4 MB', sigRequired: false, sigCount: 0,  totalEmp: 0,  signed: [] },
    { title: 'Incident Report Form',          type: 'Form',     uploaded: 'Jan 1, 2025',  size: '0.3 MB', sigRequired: false, sigCount: 0,  totalEmp: 0,  signed: [] },
    { title: 'Time Off Request Form',         type: 'Form',     uploaded: 'Jan 1, 2025',  size: '0.2 MB', sigRequired: false, sigCount: 0,  totalEmp: 0,  signed: [] },
    { title: 'Safety Training - Module 1',    type: 'Training', uploaded: 'Feb 1, 2025',  size: '1.8 MB', sigRequired: false, sigCount: 0,  totalEmp: 0,  signed: [] },
    { title: 'Safety Training - Module 2',    type: 'Training', uploaded: 'Feb 1, 2025',  size: '1.6 MB', sigRequired: false, sigCount: 0,  totalEmp: 0,  signed: [] },
    { title: 'Data Privacy Policy',           type: 'Policy',   uploaded: 'Jun 1, 2024',  size: '0.6 MB', sigRequired: false, sigCount: 0,  totalEmp: 0,  signed: [] },
  ]

  const types = ['All', 'Policy', 'Template', 'Form', 'Training']
  const typeColor = t => ({ Policy:'#4A6B8A', Template:'#4A7C59', Form:accent, Training:'#6B7D6B' }[t] || '#6B7D6B')

  const filtered = docs.filter(d =>
    (filter === 'All' || d.type === filter || (filter === 'Needs Signatures' && d.sigRequired && d.sigCount < d.totalEmp)) &&
    d.title.toLowerCase().includes(search.toLowerCase())
  )

  const stats = [
    { label: 'Total Documents',    value: docs.length,                                                   click: null },
    { label: 'Policies',           value: docs.filter(d=>d.type==='Policy').length,                      click: null },
    { label: 'Requiring Signature',value: docs.filter(d=>d.sigRequired).length,                          click: 'Needs Signatures' },
    { label: 'Fully Signed',       value: docs.filter(d=>d.sigRequired&&d.sigCount===d.totalEmp).length, click: null },
  ]

  function sendReminder(docTitle, names) {
    setToast(`Reminder sent to ${names.length} employee${names.length!==1?'s':''} for "${docTitle}"`)
    setTimeout(()=>setToast(null), 4000)
  }

  return (
    <div style={{fontFamily:"'Montserrat',sans-serif"}}>

      {/* Toast */}
      {toast && (
        <div style={{position:'fixed',top:20,right:24,zIndex:1000,background:'#2B2B2B',color:'#fff',padding:'12px 18px',borderRadius:8,fontSize:12,fontWeight:500,boxShadow:'0 4px 20px rgba(0,0,0,0.2)',display:'flex',alignItems:'center',gap:10,maxWidth:360}}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="#4A7C59" strokeWidth="1.5"/><path d="M5 8l2 2 4-4" stroke="#4A7C59" strokeWidth="1.5" strokeLinecap="round"/></svg>
          {toast}
          <button onClick={()=>setToast(null)} style={{marginLeft:'auto',background:'none',border:'none',color:'rgba(255,255,255,0.5)',cursor:'pointer',fontSize:16,lineHeight:1,padding:0}}>&times;</button>
        </div>
      )}

      <div style={{marginBottom:20,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div>
          <h1 style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600}}>Document Library</h1>
          <p style={{fontSize:11,color:'#6B7D6B',marginTop:2}}>Company-wide policies, templates, forms, and training materials</p>
        </div>
        <button style={{padding:'8px 16px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
          + Upload Document
        </button>
      </div>

      {/* Stats */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:10,marginBottom:16}}>
        {stats.map(s=>(
          <div key={s.label} onClick={s.click?()=>setFilter(s.click):undefined}
            style={{background:'#fff',border:`1px solid ${filter===s.click?accent:'#EDE6DA'}`,borderRadius:10,padding:'12px 16px',cursor:s.click?'pointer':'default',transition:'border 0.15s'}}>
            <div style={{fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:filter===s.click?accent:'#6B7D6B',fontWeight:500,marginBottom:4}}>{s.label}</div>
            <div style={{fontFamily:'Georgia,serif',fontSize:'1.5rem',color:filter===s.click?accent:'#2B2B2B',fontWeight:600}}>{s.value}</div>
          </div>
        ))}
      </div>

      <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
        {/* Filters */}
        <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
          {types.map(t=>(
            <button key={t} onClick={()=>setFilter(t)} style={{padding:'5px 14px',border:`1px solid ${filter===t?accent:'#EDE6DA'}`,borderRadius:20,background:filter===t?accent:'#fff',color:filter===t?'#fff':'#4A4A4A',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",transition:'all 0.15s'}}>
              {t}
            </button>
          ))}
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search documents..." style={{marginLeft:'auto',padding:'6px 12px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:12,fontFamily:"'Montserrat',sans-serif",outline:'none',width:200}}/>
        </div>

        {/* Active filter badge */}
        {filter === 'Needs Signatures' && (
          <div style={{padding:'8px 16px',background:'rgba(184,115,74,0.06)',borderBottom:'1px solid #EDE6DA',display:'flex',alignItems:'center',gap:8}}>
            <span style={{fontSize:11,color:accent,fontWeight:600}}>Showing: Documents needing signatures</span>
            <button onClick={()=>setFilter('All')} style={{fontSize:10,color:'#8A9E8A',background:'none',border:'none',cursor:'pointer',textDecoration:'underline',fontFamily:"'Montserrat',sans-serif"}}>Clear filter</button>
          </div>
        )}

        {/* Table */}
        <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
          <thead>
            <tr style={{background:'#F7F2EB'}}>
              {['Document','Type','Uploaded','Size','Signatures',''].map(h=>(
                <th key={h} style={{textAlign:'left',padding:'8px 16px',fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,borderBottom:'1px solid #EDE6DA'}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map((d,i)=>{
              const isExpanded = expanded === i
              const unsigned = d.sigRequired ? allEmployees.filter(e => !d.signed.includes(e.name)) : []
              return (
                <>
                  <tr key={i} style={{borderBottom: isExpanded ? 'none' : '1px solid #EDE6DA'}}
                    onMouseEnter={e=>{if(!isExpanded)e.currentTarget.style.background='rgba(184,115,74,0.04)'}}
                    onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                    <td style={{padding:'12px 16px'}}>
                      <div style={{display:'flex',alignItems:'center',gap:10}}>
                        <div style={{width:32,height:32,borderRadius:6,background:typeColor(d.type)+'22',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><rect x="3" y="2" width="10" height="12" rx="1.5" stroke={typeColor(d.type)} strokeWidth="1.25"/><path d="M5 6h6M5 9h4" stroke={typeColor(d.type)} strokeWidth="1.25" strokeLinecap="round"/></svg>
                        </div>
                        <span style={{fontWeight:500,color:'#2B2B2B'}}>{d.title}</span>
                      </div>
                    </td>
                    <td style={{padding:'12px 16px'}}>
                      <span style={{fontSize:10,padding:'2px 8px',borderRadius:8,fontWeight:600,background:typeColor(d.type)+'22',color:typeColor(d.type)}}>{d.type}</span>
                    </td>
                    <td style={{padding:'12px 16px',color:'#8A9E8A'}}>{d.uploaded}</td>
                    <td style={{padding:'12px 16px',color:'#8A9E8A'}}>{d.size}</td>
                    <td style={{padding:'12px 16px'}}>
                      {d.sigRequired ? (
                        <div style={{display:'flex',alignItems:'center',gap:8}}>
                          <div style={{flex:1,height:5,background:'#EDE6DA',borderRadius:3,overflow:'hidden',width:60}}>
                            <div style={{height:'100%',width:(d.sigCount/d.totalEmp*100)+'%',background:d.sigCount===d.totalEmp?'#4A7C59':accent,borderRadius:3}}></div>
                          </div>
                          <span style={{fontSize:11,color:d.sigCount===d.totalEmp?'#4A7C59':accent,fontWeight:600}}>{d.sigCount}/{d.totalEmp}</span>
                        </div>
                      ) : <span style={{color:'#8A9E8A',fontSize:11}}>Not required</span>}
                    </td>
                    <td style={{padding:'12px 16px'}}>
                      <div style={{display:'flex',gap:6}}>
                        <button style={{padding:'4px 10px',border:'1px solid #EDE6DA',borderRadius:5,background:'#fff',fontSize:11,color:'#6B7D6B',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>View</button>
                        {d.sigRequired && (
                          <button onClick={()=>setExpanded(isExpanded?null:i)}
                            style={{padding:'4px 10px',border:`1px solid ${isExpanded?accent:'#EDE6DA'}`,borderRadius:5,background:isExpanded?accentBg:'#fff',fontSize:11,color:isExpanded?accent:'#6B7D6B',cursor:'pointer',fontFamily:"'Montserrat',sans-serif",fontWeight:isExpanded?600:400}}>
                            {isExpanded ? 'Hide' : 'Who?'}
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                  {isExpanded && (
                    <tr key={i+'-expand'} style={{borderBottom:'1px solid #EDE6DA'}}>
                      <td colSpan={6} style={{padding:'0 16px 16px 58px',background:'rgba(184,115,74,0.02)'}}>
                        <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:16}}>
                          <div style={{flex:1}}>
                            {unsigned.length === 0 ? (
                              <div style={{display:'flex',alignItems:'center',gap:8,padding:'10px 0'}}>
                                <span style={{color:'#4A7C59',fontSize:13,fontWeight:600}}>✓ All employees have signed this document!</span>
                              </div>
                            ) : (
                              <>
                                <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#A0392B',fontWeight:600,marginBottom:10}}>
                                  Unsigned ({unsigned.length})
                                </div>
                                <div style={{display:'flex',flexWrap:'wrap',gap:8,marginBottom:12}}>
                                  {unsigned.map((e,j)=>(
                                    <div key={j} style={{display:'flex',alignItems:'center',gap:6,padding:'4px 10px',background:'rgba(160,57,43,0.06)',border:'1px solid rgba(160,57,43,0.15)',borderRadius:20}}>
                                      <div style={{width:20,height:20,borderRadius:'50%',background:'rgba(160,57,43,0.15)',color:'#A0392B',fontSize:9,fontWeight:700,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>{e.initials}</div>
                                      <span style={{fontSize:11,color:'#A0392B',fontWeight:500}}>{e.name}</span>
                                    </div>
                                  ))}
                                </div>
                                <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#4A7C59',fontWeight:600,marginBottom:10}}>
                                  Signed ({d.signed.length})
                                </div>
                                <div style={{display:'flex',flexWrap:'wrap',gap:8}}>
                                  {allEmployees.filter(e=>d.signed.includes(e.name)).map((e,j)=>(
                                    <div key={j} style={{display:'flex',alignItems:'center',gap:6,padding:'4px 10px',background:'rgba(74,124,89,0.06)',border:'1px solid rgba(74,124,89,0.15)',borderRadius:20}}>
                                      <div style={{width:20,height:20,borderRadius:'50%',background:'rgba(74,124,89,0.15)',color:'#4A7C59',fontSize:9,fontWeight:700,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>{e.initials}</div>
                                      <span style={{fontSize:11,color:'#4A7C59',fontWeight:500}}>{e.name}</span>
                                    </div>
                                  ))}
                                </div>
                              </>
                            )}
                          </div>
                          {unsigned.length > 0 && (
                            <div style={{flexShrink:0,paddingTop:4}}>
                              <button onClick={()=>sendReminder(d.title, unsigned)}
                                style={{padding:'8px 16px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",whiteSpace:'nowrap'}}>
                                Send Reminder to All ({unsigned.length})
                              </button>
                              <div style={{fontSize:10,color:'#8A9E8A',marginTop:6,textAlign:'right'}}>Sends in-app + email notification</div>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
